export enum TripStartValidationErrors {
  None = 0,
  LocalChanges = 1
}
